import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom'; // Import useNavigate from react-router-dom
import 'styles/settings/Transactions.css';
import {getUserTransactionsOverviewRequest} from 'util/api';
import {centsToString} from 'util/cashFormatter';
import UniversalEmptyPageHeader from 'components/universal/UniversalEmptyPageHeader';

const Transactions = () => {
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate(); // Initialize navigate

    const TRANSACTION_TYPE_LABELS = {
        IMAGE: "Images published",
        KEY: "Keys",
        CHAT_MESSAGE: "Messages sent",
        ITEM_BUY: "Items purchased",
        ITEM_SELL: "Items sold",
        STRIPE: "Funds added",
        GRAPH: "Graphs purchased",
        IMAGE_COMMENT_PIN: "Comments pinned",
        IMAGE_COMMENT_REACTION: "Comments reacted",
        CHARITY_LINK: "Charities supported",
    };

    const getTransactionLabel = (type) => {
        return TRANSACTION_TYPE_LABELS[type] ?? type;
    };

    useEffect(() => {
        const fetchTransactions = async () => {
            try {
                const data = await getUserTransactionsOverviewRequest();
                // Transform the data into an array of transaction objects
                const transactionsArray = Object.entries(data).map(([type, amount]) => ({
                    type,
                    amount,
                }));
                setTransactions(transactionsArray);
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchTransactions();
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div>
            <UniversalEmptyPageHeader text={'History'} image={'credit-card'} desktopText={true}/>
            <table className="items-table">
                <thead>
                <tr>
                    <th>Type</th>
                    <th>Cash</th>
                </tr>
                </thead>
                <tbody>
                {transactions.map((transaction, index) => (
                    <tr
                        key={index}
                        onClick={() => navigate(`/history/${transaction.type}`)} // Add onClick handler
                        className="clickable-row" // Add a class for styling
                    >
                        <td>{getTransactionLabel(transaction.type)}</td>
                        <td
                            style={{
                                color: transaction.amount < 0 ? 'red' : 'green',
                            }}
                        >
                            {centsToString(Math.abs(transaction.amount))}
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default Transactions;
